/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {useStore} from "zustand";
import {Button, Descriptions, Table, TableColumnsType, Tag} from "antd";
import {User} from "../../../../types/User";
import userAPI from "../../../../api/userAPI";
import {emptyUserMannerAPIRes, GetUserMannerAPIResInterface} from "../../../../types/GetUserMannerAPIRes.interface";
import {formatKorDate} from "../../../../util/date";
import {UserMannerCodeEnum} from "../../../../types/Type";
import {useMessageStore} from "../../../../stores/messageStore";

interface UserMannerTabProps {
	selectedItem: User | undefined;
}

const UserMannerTab = ({ selectedItem }: UserMannerTabProps) => {
	const { setMessages } = useStore(useMessageStore);
	const [data, setData] = useState<GetUserMannerAPIResInterface>(emptyUserMannerAPIRes);

	const onReset = async () => {
		if (!selectedItem?.id) return;

		try {
			const userId = selectedItem.id;
			await userAPI.resetUserMannerAPI(userId);
			setMessages('success', `${selectedItem.name} 매너 평가 초기화 완료`);
			await fetchUserManner();
		} catch (e) {
			console.error(e);
		}
	};


	const columns: TableColumnsType<GetUserMannerAPIResInterface['detailList'][number]> = [
		{
			title: 'createDate',
			dataIndex: 'createDate',
			key: 'createDate',
			width: 80,
			align: 'center',
			render: (value: any) => formatKorDate(value),
		},
		{
			title: 'updateDate',
			dataIndex: 'updateDate',
			key: 'updateDate',
			width: 80,
			align: 'center',
			render: (value: any) => formatKorDate(value),
		},
		{
			title: 'type',
			dataIndex: 'type',
			key: 'type',
			width: 80,
			align: 'center',
			render: (value) => {
				const color = value === 'great'
						? 'green'
						: value === 'good'
							? 'blue'
							: 'red';
				return <Tag color={color}>{value}</Tag>
			},
		},
		{
			title: 'code',
			dataIndex: 'code',
			key: 'code',
			width: 80,
			align: 'center',
			render: (value: any) => value,
		},
		{
			title: 'message',
			dataIndex: 'message',
			key: 'message',
			width: 80,
			align: 'center',
			render: (code: UserMannerCodeEnum, record: any) => {
				if (!code) return '';

				return record.message;
			},
		},
		{
			title: 'count',
			dataIndex: 'count',
			key: 'count',
			width: 80,
			align: 'center',
			render: (value: any) => value,
		},
		{
			title: 'isValid',
			dataIndex: 'isValid',
			key: 'isValid',
			width: 80,
			align: 'center',
			render: (value: any) => value
				? <Tag color="blue">TRUE</Tag>
				: <Tag color="red">FALSE</Tag>,
		},
	];

	const fetchUserManner = async () => {
		if (!selectedItem?.id) return;

		try {
			const res = await userAPI.fetchUserMannerAPI(selectedItem.id);
			setData(res);
		} catch (e) {
			console.error(e);
		}
	};

	useEffect(() => {
		fetchUserManner();
	}, [selectedItem?.id]);

	return (
		<div
			className={``}
		>
			<Descriptions
				title="매너"
				bordered
				column={1}
				layout="vertical"
				size="small"
			>
				<Descriptions.Item label="매너 온도">{data.point}</Descriptions.Item>
				<Descriptions.Item label="180일 평가 건수">{data.countLastDays}</Descriptions.Item>
				<Descriptions.Item label="만족도">{data.countGreatAndGood}</Descriptions.Item>
			</Descriptions>

			<Table
				title={() => (
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div>매너 평가 세부 항목</div>
						<Button onClick={onReset}>평가 리셋</Button>
					</div>
				)}
				columns={columns}
				dataSource={data.detailList}
				rowKey={(item) => item.id}
			/>
		</div>
	);
};

export default UserMannerTab;
